export const MEASUREMENT_ID = 'G-M7JECLPM6S';
export const CONSENT_KEY = 'delps.analytics-consent.v1';
export const DISMISSED_KEY = 'delps.analytics-dismissed.v1';
export const ENABLED = process.env.NEXT_PUBLIC_GA_ENABLED === 'true';

export type Consent = 'accepted' | 'rejected' | null;

export type AnalyticsWindow = Window & {
  dataLayer?: IArguments[];
  gtag?: (...args: unknown[]) => void;
  delpsAnalyticsInitialized?: boolean;
} & Record<string, any>;

export interface UseAnalyticsResult {
  hydrated: boolean;
  open: boolean;
  scriptSrc: string | null;
  togglePreferences: () => void;
  closePreferences: () => void;
  acceptCookies: () => void;
  rejectCookies: () => void;
}
